export enum IconType {
  SVG = "svg",
  IMAGE = "image",
  NONE = "none",
}
export interface NavigationItem {
  title: string;
  icon: string;
  launchPoint: string;
  isRedirect: boolean;
  path: string;
}

export interface NavigationGroup {
  name: string;
  icon: string;
  items: NavigationItem[];
}

export type NavigationRow = NavigationItem | NavigationGroup;
